export const MAX_MOBILE_SIZE = 800;
export const DEFAULT_STATIC_MENU_WIDTH = 284;
export const MAX_POPUP_MENU_PERCENT = 0.8;
export const MAX_POPUP_MENU_WIDTH = 550;
